





















































































































































































































































































































import { wrapper as AssetManagerComposer } from '@/composers/asset-manager';
import { component as DirtyCheckComposer } from '@/composers/dirty-check';
import { component as FetchDataComposer } from '@/composers/fetch-data';
import { component as StoreRegisterComposer } from '@/composers/store-register';
import messages from '../../messages';
import store from '../../store/product';
import View from './View';

const storeName = 'product';

export default AssetManagerComposer(
  DirtyCheckComposer(storeName,
    FetchDataComposer(
      StoreRegisterComposer(
        storeName,
        store,
        View(storeName),
      ),
    ),
  ),
  messages,
) as IView;
